import { render, staticRenderFns } from "./Col3Demo.vue?vue&type=template&id=0072d474&scoped=true"
import script from "./Col3Demo.vue?vue&type=script&lang=js"
export * from "./Col3Demo.vue?vue&type=script&lang=js"
import style0 from "./Col3Demo.vue?vue&type=style&index=0&id=0072d474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0072d474",
  null
  
)

export default component.exports